import { attributes, AttributesMixin, define, type } from "@type-r/models";
import { AssetData, AssetType } from "./assetData";
import { CommonParticipant } from "./commonParticipant";
import { Component } from "./component";

export interface CreditNote extends AttributesMixin<typeof CreditNote> { }

export const AssetNumber = attributes({
    number: type(String).value(null)
});

export const Invoice = attributes({
    creditAmount: type(Number).value(0),
    appliedAmount: type(Number).value(0),
    ...AssetNumber.attributes
});

export const Details = attributes({
    invoice: Invoice,
    saleOrder: type(AssetNumber).value(new AssetNumber()),
    purchaseOrder: type(AssetNumber).value(new AssetNumber()),
    components: type([Component]).value([])
});

@define
export class CreditNote extends AssetData {
    static attributes = {
        ...AssetData.attributes,
        assetType: type(AssetType).value({ id: 7, name: 'creditNote' }),
        buyer: CommonParticipant,
        supplier: CommonParticipant,
        reason: String,
        description: String,
        amount: type(Number).value(0),
        outstandingAmount: type(Number).value(0),
        currency: String,
        issuanceDate: type(Date).null,
        paymentTerms: String,
        expirationDate: type(Date).null,
        postedOn: type(Date).null,
        detail: type(Details).value(new Details()),
        validationCategory: type(Number).dontSave,
    }
    isLoaded: boolean;

    get isDigitized() {
        return this.state.name == 'Digitized';
    }

    onLoaded() {
        const defaultValues = new CreditNote();
        this.set({ state: defaultValues.state.clone() });
        if (!this.assetType) this.set({ assetType: defaultValues.assetType.clone() });
        if (!this.supplier) this.set({ supplier: defaultValues.supplier.clone() });
        if (!this.buyer) this.set({ buyer: defaultValues.buyer.clone() });
        if (!this.detail) this.set({ detail: defaultValues.detail.clone() });

        this.isLoaded = true;
    }
}
